// ManagementTeamData.js
export const managementTeamData = {
    title: "Management Team",
    description: "Meet our leadership team driving innovation and success.",
    teamMembers: [
      {
        name: "John Doe",
        role: "CEO",
        bio: "John has over 20 years of experience in the industry, leading companies to global success.",
        image: "images/person.png",
      },
      {
        name: "Jane Smith",
        role: "CFO",
        bio: "Jane is a financial expert with a proven track record in managing large-scale budgets.",
        image: "images/person.png",
      },
      {
        name: "Alice Johnson",
        role: "CTO",
        bio: "Alice is a technology visionary, driving innovation and digital transformation.",
        image: "images/person.png",
      },
      {
        name: "Bob Brown",
        role: "COO",
        bio: "Bob specializes in operational excellence and ensuring seamless business processes.",
        image: "images/person.png",
      },
    ],
  };